import { useState } from 'react';
import { useResellingProgramsContext } from '../context';

export const useSubscriptionDrawer = () => {
    const { isOpenSubscriptionDrawer } = useResellingProgramsContext();

    const [isOpenDrawer, setIsOpenDrawer] = useState(isOpenSubscriptionDrawer);

    const handleOpen = () => setIsOpenDrawer(true);
    const handleClose = () => setIsOpenDrawer(false);

    return {
        isOpenSubscriptionDrawer: isOpenDrawer,
        onOpenSubscriptionDrawer: handleOpen,
        onCloseSubscriptionDrawer: handleClose,
    };
};
